import { CalculationStepRoutes } from '../../calculation.constants';
import { CalculationTypeEnum } from '../../../../api/models';

export interface StepNavigationButton {
  route: CalculationStepRoutes;
  text: string;
  gaEvent: string;
}

export interface NavigationButton extends StepNavigationButton {
  direction: NavigationDirection;
}

export enum NavigationDirection {
  Back,
  Forward,
}

export const autoCalculationSteps: StepNavigationButton[] = [
  {
    route: CalculationStepRoutes.MODELS,
    text: 'Modele',
    gaEvent: 'models',
  },
  {
    route: CalculationStepRoutes.MEASUREMENTS,
    text: 'Măsurători',
    gaEvent: 'measurements',
  },
  {
    route: CalculationStepRoutes.SKETCHES,
    text: 'Schițe',
    gaEvent: 'sketches',
  },
  {
    route: CalculationStepRoutes.ACCESSORIES,
    text: 'Accesorii',
    gaEvent: 'accessories',
  },
];

export const manualCalculationSteps: StepNavigationButton[] = [
  {
    route: CalculationStepRoutes.MODELS,
    text: 'Modele',
    gaEvent: 'models',
  },
  {
    route: CalculationStepRoutes.MEASUREMENTS,
    text: 'Măsurători',
    gaEvent: 'measurements',
  },
  {
    route: CalculationStepRoutes.ACCESSORIES,
    text: 'Accesorii',
    gaEvent: 'accessories',
  },
];

export const navigationTree = {
  [CalculationTypeEnum.OneSlope]: autoCalculationSteps,
  [CalculationTypeEnum.TwoSlopes]: autoCalculationSteps,
  [CalculationTypeEnum.FourSlopes]: autoCalculationSteps,
  [CalculationTypeEnum.Custom]: manualCalculationSteps,
  [CalculationTypeEnum.CustomShape]: manualCalculationSteps,
  [CalculationTypeEnum.FenceSlat]: manualCalculationSteps,
  [CalculationTypeEnum.FencePanel]: manualCalculationSteps,
};
